module.exports=function(scope){ return `// Pass your RSA public key to be used in PEM format
Zoom.sdk.setFacemapEncryptionKey(
  "-----BEGIN PUBLIC KEY-----\\n" +
  "Your-Public-Key-Line-1-Here\\n" +
  "Your-Public-Key-Line-2-Here\\n" +
  "Your-Public-Key-Line-3-Here\\n" +
  "Your-Public-Key-Line-4-Here\\n" +
  "Your-Public-Key-Line-5-Here\\n" +
  "Your-Public-Key-Line-6-Here\\n" +
  "Your-Public-Key-Line-7-Here\\n" +
  "Your-Public-Key-Etc.-Here\\n" +
  "-----END PUBLIC KEY-----")
`};


// WEBPACK FOOTER //
// ./src/resources/code/ios/encryption-keys.swift.tpl